import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  overflow: scroll;
`;

export const Body = styled.div`
  display: flex;
  column-gap: 16px;
  margin-bottom: 32px;
  max-height: 838px;
`;

export const Left = styled.div`
  height: fit-content;
  margin-left: 32px;
`;

export const Right = styled.div`
  background-color: white;
  margin-right: 32px;
  border-radius: 8px;
  width: 100%;
`;
